import Pilot from '@/models/Pilot';
import Countries from '@/models/Countries';
import PilotRanks from '@/models/PilotRanks';
import Aircrafts from '@/models/Aircrafts';

export default class Squadron {
  constructor({
    name = 'Red',
    color = '#ff0000',
    pilots = [],
    country = Countries[0],
  }) {
    this.name = name;
    this.color = color;
    this.pilots = pilots;
    this.country = country;
  }

  addPilot() {
    this.pilots.push(new Pilot({
      id: this.pilots.length + 1,
      name: 'A. Pilot',
      rank: PilotRanks[4],
      aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
    }));
  }

  removePilot(pilot) {
    this.pilots = this.pilots.filter((x) => x !== pilot);
    this.pilots = this.pilots.map((x, i) => { // eslint-disable-line
      return {
        ...x,
        id: (i + 1),
      };
    });
  }

  toJSON() {
    return {
      name: this.name,
      color: this.color,
      country: this.country,
      pilots: this.pilots.map((x) => x.toJSON()),
    };
  }

  static fromJSON(json) {
    return new Squadron({
      name: json.name,
      color: json.color,
      country: json.country,
      pilots: json.pilots.map((x) => Pilot.fromJSON(x)),
    });
  }
}
